var userAgent = require('../internals/engine-user-agent');

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/engine-is-ios.js